import { ThemeConfig } from "antd";

export const antdLightTheme: ThemeConfig["token"] = {
  colorPrimary: '#05F',
  colorTextBase: 'rgba(0, 0, 0, 0.96)',
  controlItemBgActiveHover: 'rgba(162, 212, 255, 0.2)',
  controlItemBgHover: 'rgba(54, 108, 178, 0.06)',
  colorSplit: 'rgba(31, 51, 77, 0.1)',
  // colorBgContainer: '#F7F7F7',
  // colorBgContainer: 'linear-gradient(to bottom, #ebf5ff, #e8eeff)',
  // colorBgElevated: '#ffffff',
  colorBgSpotlight: '#fff',
  fontFamily: 'Inter',
};
export const antdLightComponentsTheme: ThemeConfig['components'] = {
  Input: {
    colorBgContainer: '#F7F7F7',
    colorTextPlaceholder:'rgba(38, 45, 77, 0.30)'
  },
  Select: {
    colorBgContainer: '#F7F7F7', // 下拉菜单背景
  },
  DatePicker: {
    colorBgContainer: '#F7F7F7', // 下拉菜单背景
  },
  Card: {
    colorBgContainer: '#fff', // 使用 CSS 变量
  },
  Tooltip: {
    colorBgSpotlight: '#fff', // 背景颜色
    colorTextLightSolid: '#000', // 文字颜色（推荐白色）
  },
  Layout: {
    bodyBg: 'linear-gradient(to bottom, #ebf5ff, #e8eeff)',
  },
}